var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFb = function SvgFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "22 7 45 45",
    role: "img",
    "aria-label": "[title]"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Facebook")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M63.5 29.2a19 19 0 10-38 0 19 19 0 0016 18.9V34.7h-4.8v-5.5h4.8V25c0-4.8 2.8-7.4 7.2-7.4 2.1 0 4.3.4 4.3.4v4.7h-2.4c-2.4 0-3.1 1.5-3.1 3v3.6h5.3l-.8 5.5h-4.4v13.4c9-1.5 15.9-9.4 15.9-19z"
  })));
};
export default SvgFb;